import { Button } from '@mui/material'
import { useTranslate } from '@tolgee/react'
import { Header } from '@tom-ui/ui'
import { useNavigate } from 'react-router'

export const PiersHeader = () => {
  const { t } = useTranslate()
  const navigate = useNavigate()
  const title = t('Piers', 'Piers')

  return (
    <Header
      title={title}
      position='relative'
      rightRenderOption={
        <Button
          sx={{ flex: 'none' }}
          variant='contained'
          onClick={() => navigate('new')}
          data-cy='add-pier-btn'
        >
          {t('addPier', 'Add pier')}
        </Button>
      }
    />
  )
}
